module.exports = __webpack_public_path__ + "static/story7-5639a6869ce105e54b688a29c7e91a08.png";